import React from 'react'
import classNames from 'classnames'

type Props = {
  text: string
  ingress: boolean
}

export const ParagraphBlock = (props: Props) => {
  const { text, ingress } = props
  return <p className={classNames({ 'p-ingress': ingress })}>{text}</p>
}
